import { useState, useEffect } from 'react';

/**
functions that update the DOM
separated out so we can mock them during testing
otherwise testing craps out
*/

function createRootElement() {
  let modalRootElem = document.getElementById('st-modal-root');
  if (!modalRootElem) {
    modalRootElem = document.createElement('div');
    modalRootElem.setAttribute('id', 'st-modal-root');
    modalRootElem.classList.add('st_modal-root');
    document.body.appendChild(modalRootElem);
  }
  return modalRootElem;
}

/**
Modal Hook to manage creation of modal portal root element
The actual function to manipulate the DOM has been moved out
In order to mock it during testing
*/

function useModalPortal(params = {}) {
  const {
    portalTarget: initialPortalTarget
  } = params;
  const [portalTarget, setPortalTarget] = useState(initialPortalTarget || null);
  useEffect(() => {
    if (portalTarget) {
      setPortalTarget(portalTarget);
    } else {
      setPortalTarget(createRootElement());
    }
  }, [setPortalTarget, portalTarget]);
  return {
    renderNode: portalTarget
  };
}

export { useModalPortal as default };
